import { render, staticRenderFns } from "./PerfectScrollbar.vue?vue&type=template&id=2d176fd2&"
import script from "./PerfectScrollbar.vue?vue&type=script&lang=js&"
export * from "./PerfectScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./perfect-scrollbar.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports